import { Box, styled } from '@mui/material';

import Page from '@/components/Page/index.ts';
import { competitionWinnersQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';

import type { Route } from './+types/LandingPage';
import { CompetitionsSection } from './_sections/CompetitionsSection.tsx';
import { MidSection } from './_sections/MidSection.tsx';
import { TopSection } from './_sections/TopSection.tsx';

const Root = styled('div')({
  width: '100%',
  backgroundColor: 'white',
});

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const competitions = await queryClient.query(competitionWinnersQuery());
  const winners = competitions.find((c) => c.slug === 'advent_2025_campaign')?.winners;
  const currentIndex = competitions.findIndex(
    (competition) => competition.slug === 'advent_2025_campaign',
  );
  const startIndex = currentIndex + 1;
  const previousCompetitions = competitions.slice(startIndex);
  return { winners, previousCompetitions };
}

export default function LandingPage({ loaderData }: Route.ComponentProps) {
  return (
    <Page title="Julekalender">
      <Root>
        <TopSection winners={loaderData.winners || []} />
        <MidSection />
        <CompetitionsSection competitions={loaderData.previousCompetitions} />
        {/* Ensure footer decorations do not overlap with previous section */}
        <Box sx={{ mb: { xs: 10, lg: 0 } }} />
      </Root>
    </Page>
  );
}
